// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"b961357a","87":"030e1e6d","111":"2cbbe1f8","450":"43f01468"}[chunkId] + ".css";
};